import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WasteModuleService } from 'src/app/services/waste-module.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { ROUTE_PATHS } from 'src/app/route-paths';
import { Subject } from 'rxjs';
import { PrintAuthUrlService } from 'src/app/services/print-auth-url.service';

@Component({
    selector: 'app-retrieval-log-collect',
    templateUrl: './retrieval-log-collect.component.html',
    styleUrls: ['./retrieval-log-collect.component.css'],
    standalone: false
})
export class RetrievalLogCollectComponent implements OnInit, OnDestroy {
  private wasteModService = inject(WasteModuleService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private printAuthUrlService = inject(PrintAuthUrlService);
  authService = inject(AuthService);

  cols!: any[];
  formCols!: any[];
  records: any[] = [];
  totalCount: any = 0;
  id = "";
  retreivalLogData: any[] = [];
  retreivalLogSelectedData: any[] = [];
  totalExpectedCounts = 0;
  totalActualCounts = 0;
  masterSelected!: boolean;
  checklist: any;
  checkedList: any;
  templeteType = 'list'
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.cols = [
      { field: 'device', header: 'Collection Location' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'endDate', header: 'End Date' },
      { field: 'expectedCounts', header: 'Expected Count' },
      //{ field: 'actualCounts', header: 'Actual Count' },
      //{ field: '', header: 'Comments' },
      { field: '', header: 'Collect Location' }
    ];
    this.formCols = [
      { field: 'endDate', header: 'End Date' },
      { field: 'time', header: 'Time' },
      { field: 'device', header: 'Location' },
      { field: 'expectedCounts', header: 'Expected Count' },
      { field: 'bag', header: 'Bag' },
      { field: 'actualCounts', header: 'Actual Count' },
      { field: 'recon', header: 'Recon' },
    ];
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.wasteModService.getRetrievalLogData(this.id).subscribe((res) => {

        this.retreivalLogData = (res as any)["retrievalRecords"];
        this.retreivalLogData = this.retreivalLogData.sort((a, b) => a.device.toLowerCase() > b.device.toLowerCase() ? 1 : -1);
        this.setInitialPrintSelectionState()
        this.calculateTotalExpectedCounts()
        this.calculateActualExpectedCounts()
      })
    })
  }

  setInitialPrintSelectionState() {
    this.retreivalLogData.forEach(record => {
      record["isSelected"] = false;
    })
  }

  calculateTotalExpectedCounts() {
    this.totalExpectedCounts = 0;
    this.retreivalLogData.forEach(record => {
      this.totalExpectedCounts = this.totalExpectedCounts + record["expectedCounts"]
    })
  }

  calculateActualExpectedCounts() {
    this.totalActualCounts = 0;
    this.retreivalLogData.forEach(record => {
      if (!["", null].includes(record["actualCounts"]))
        this.totalActualCounts = this.totalActualCounts + Number(record["actualCounts"])
    })
  }


  updateRetrievalLogData(mode: any) {
    const data = {};
    (data as any)["id"] = this.id;
    (data as any)["mode"] = mode;
    (data as any)["records"] = this.retreivalLogData;
    this.wasteModService.saveRetrievalLogData(data).subscribe((res) => {
      alert("retrieval log saved successfully")
      if ((res as any)["status"] == "Completed") {
        this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/retrieval-log/index'])
      }


      this.calculateActualExpectedCounts()
    })
  }

  navToIndex() {
    this.router.navigate(['/' + ROUTE_PATHS.assayManagement + '/retrieval-log/index'])
  }


  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (const retrievalLog of this.retreivalLogData) {
      retrievalLog.isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (const retrievalLog of this.retreivalLogData) {
      if (retrievalLog.isSelected) {
        const tempLogData =Object.assign({}, retrievalLog);
        const datetime = new Date();
        tempLogData.endDate=datetime.toISOString().slice(0, 10);
        this.checkedList.push(tempLogData);
      }

    }

  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.retreivalLogData.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  openPrintUrl() {

    const selectedForPrint: any[] = [];
    for (const retrievalLog of this.retreivalLogSelectedData) {
      selectedForPrint.push(retrievalLog);
    }
    if (selectedForPrint.length <= 0) {
      alert('Please select Stock Areas you will be collecting waste from using the "collect Stock Area" column before you print.');
      return false;
    }

    const stagedForPrint = this.wasteModService.generateRetrievalLogsForPrint(selectedForPrint);
    const facility = this.retreivalLogSelectedData[0].facility;
    const data = JSON.stringify(stagedForPrint);
    const url = environment.apiUrl + 'print-retrieval';
    this.wasteModService.requestRetrievalToken(data, facility).subscribe(
      (res) => this.printAuthUrlService.openAuthenticatedPrint(
        url + "?token=" + (res as any)["id"] + "&witnesstoken=" + this.authService.getWitnessToken()
      )
    )

  }
  openForm() {
    if (this.checkedList == undefined) {
      alert('Please select Stock Areas you will be collecting waste from using the "collect Stock Area" column before you print.');
      return false;
    }
    this.retreivalLogSelectedData = this.checkedList;
    this.templeteType = 'create'
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
